<template>

	<div class="container">
		<recovery-component :recoveryCode="recoveryCode"></recovery-component>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';
	import Recover from './Recover';
	import store from '@/store';

	export default {
		name: 'RecoveryPage',
		components: {
			'recovery-component': Recover
		},
		beforeRouteEnter(to, from, next) {

			//Wait till get env variables - because of recaptcha codes
			store.state.envPromise.then(() => {
				next();
			});
		},
		data() {
			return {}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			recoveryCode() {
				return this.$route.params['recoveryCode']
			}
		},
		mounted() {

		}
	}
</script>
<style lang="scss">
	@import "../../scss/components/auth";
</style>